import httpClient from "./httpClient";

export async function createCouponSubmission(body) {
  const { data } = await httpClient.post("/coupon-submissions", body);
  return data.submission;
}
